<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah/hiring`">招工招生</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah/column/meeting/list`">企业招聘会</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content">
        <div class="head">
          <h3 class="title">{{ model.title }}</h3>
          <div class="attrs">
            <span class="time">举办时间：{{ model.time }}</span>
            <span class="source">举办单位：{{ model.source }}</span>
          </div>
        </div>
        <div class="content" v-html="model.content"></div>
        <div class="relative">
          <div class="prev">
            上一篇：
            <!-- <router-link v-if="model.prev" :to="'/feature/ah/column/detail/' + model.prev.id">{{ model.prev.title }}</router-link> -->
            <router-link v-if="model.prev" :to="`${$subsitePrefix}/ah/column/meeting/detail/${this.name}?id=${model.prev.Id}`">{{ model.prev.Name }}</router-link>
            <span v-else>没有了</span>
          </div>
          <div class="next">
            下一篇：
            <router-link v-if="model.next" :to="`${$subsitePrefix}/ah/column/meeting/detail/${this.name}?id=${model.next.Id}`">{{ model.next.Name }}</router-link>
            <!-- <router-link v-if="model.next" :to="'/feature/ah/column/detail/' + model.next.id">{{ model.next.title }}</router-link> -->
            <span v-else>没有了</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentAndAdjacent } from "api/app";
import { mapState } from "vuex";

export default {
  data() {
    return {
      model: {
        title: "",
        time: "",
        source: "",
        content: "",
        id: "1",
        prev: null,
        next: null
      },
      id: null
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    }
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  methods: {
    loadData() {
      getCurrentAndAdjacent({ id: this.id, name: this.name, college: this.collegeData.college.Id }).then(res => {
        const item = res.current
        const arr = {
          title: item.Name,
          time: item.current,
          source: item.Organizer,
          content: item.Description,
          prev: res.prev,
          next: res.next
        }
        this.model = arr || {};
      });
    },
    init() {
      this.name = this.$route.params.id;
      this.id = this.$route.query.id;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .title {
    font-size: 32px;
    color: #333333;
    font-weight: 500;
    padding: 8px 0 15px 0;
    line-height: 1.4em;
  }
  .head {
    margin: 0 -72px 32px -72px;
    border-bottom: 1px solid #eee;
    padding: 0 72px;
  }
  .attrs {
    font-size: 16px;
    color: #999999;
    line-height: 18px;
    padding-bottom: 24px;
    .time {
      padding-right: 30px;
    }
  }
  .content {
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    line-height: 1.8em;
    ::v-deep p {
      text-indent: 2em;
      padding-bottom: 1em;
    }
  }
  .relative {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    border-top: 1px solid #eee;
    margin-top: 40px;
    font-size: 16px;
    .prev {
    }
    .next {
    }
  }
  .g-content {
    padding: 24px 72px 40px 72px;
  }
}
</style>
